import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { propertyDetailApi } from '../../../core/http/httpClient';

export const usePropertyDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [property, setProperty] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    propertyDetailApi
      .call({ id })
      .then((res: any) => {
        setProperty(res.data);
        setLoading(false);
      })
      .catch(() => {
        setProperty(null);
        setLoading(false);
      });
  }, [id]);

  return { property, loading };
};